import React from "react";
import { PanelAddFaq } from "../../../UI/Faqs/Add/PanelAddFaq";

const AddFaq = () => {
  return (
    <div>
      <PanelAddFaq />
    </div>
  );
};

export default AddFaq;
